import gql from "graphql-tag";
import request, { GET_REQUESTS } from "./request_v2_gql";
import graphqlClient, { fragments as requestFragments } from "@/http/graphql/request";

export default {
	request,
	initDataRequestManagement(payload) {
		const queryOptions = {
			query: gql`query RequestManagement (
					$limit: Int!,
					$page: Int!,
					$search: String,
					$req_type_id: Int,
					$to_date: String,
					$can_edit: Boolean,
					$from_date: String,
					$list_statuses: [Int],
					$req_type_type_id: Int,
					$list_requested_by: [Int],
					$waiting_approval: Boolean,
					$advantage_search: String,
					$orderBy: OrderByObject,
					$requested_by_me: Boolean,
					$approve_by_me: Boolean
				) {
					${GET_REQUESTS}
				}
				${requestFragments.Request}
			`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1,
				search: payload.search || "",
				orderBy: payload.orderBy || null,
				to_date: payload.to_date || null,
				can_edit: payload.can_edit || null,
				from_date: payload.from_date || null,
				list_statuses: payload.list_statuses,
				req_type_id: payload.req_type_id,
				requested_by_me: payload.requested_by_me,
				approve_by_me: payload.approve_by_me || false,
				req_type_type_id: payload.req_type_type_id,
				advantage_search: payload.advantage_search || null,
				waiting_approval: payload.waiting_approval || false,
				list_requested_by: payload.list_requested_by || null
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				requests: response.data.requests
			};
		});
	}
};
